import { IconChainRounded } from "../../../assets/icons";
import { useBot } from "../../../context/botContext";
import { formatCurrency, getAssetName } from "../../../utils";
import CoinLogo from "../../commons/CoinLogo";

const AvailableForTrade = ({
  userBalance,
  loadingBalance,
  selectedExchange,
  selectedPair,
  exchangeName,
  coinName,
}) => {
  const { openDialogBot } = useBot();
  const displayExchangeName = selectedExchange?.name || exchangeName;
  const displayCoinName = selectedPair?.pair || coinName;

  return (
    <div
      className={`p-4 px-5 border rounded-xl flex items-center justify-between ${
        displayExchangeName && displayCoinName
          ? userBalance > 0
            ? "bg-[#98F5F31A] border-[#007A78]"
            : "bg-[#98F5F31A] border-[#D2D3D6]"
          : ""
      }`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="w-full">
        <div className="flex flex-col justify-between">
          <div className="text-base text-[#999]">Available for trade</div>
          <span className="text-xl font-bold">
            {displayExchangeName || displayCoinName
              ? loadingBalance
                ? "Checking balance..."
                : `${formatCurrency(userBalance)} ${
                    selectedPair?.base_currency ?? "USDT"
                  }`
              : "-"}
          </span>
        </div>
        {openDialogBot !== "step-bot-2-edit" && (
          <div
            className={`text-sm mt-1 ${
              userBalance >= 5 ? "text-[#34C759]" : "text-[#FF0000]"
            }`}
          >
            {displayExchangeName && displayCoinName && !loadingBalance
              ? userBalance >= 5
                ? "The balance is sufficient to run the bot."
                : "Insufficient balance to run the bot."
              : ""}
          </div>
        )}
      </div>
      <div className="flex items-center -space-x-3">
        {displayExchangeName ? (
          <img
            src={`/images/icons/icon_wallet_${displayExchangeName.toLowerCase()}.svg`}
            alt=""
            className="w-10 h-10 rounded-full border"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        ) : (
          <div>
            <IconChainRounded className="w-[40px] h-[40px]" />
          </div>
        )}
        {displayCoinName ? (
          // <img
          // src={getAssetCoin(displayCoinName.split("/")[0])}
          //   alt=""
          //   className="w-10 h-10 rounded-full"
          //   onError={(e) => {
          //     e.currentTarget.style.display = "none";
          //   }}
          // />
          <CoinLogo
            asset={getAssetName(displayCoinName)}
            className="w-10 h-10 rounded-full bg-white border"
          />
        ) : (
          <div>
            <IconChainRounded className="w-[40px] h-[40px]" />
          </div>
        )}
      </div>
    </div>
  );
};

export default AvailableForTrade;
